export default function isAtBottom(
  event: React.UIEvent<HTMLDivElement>,
  offset: number
): boolean {
  const target = event.target as HTMLDivElement;
  return target.clientHeight + target.scrollTop >= target.scrollHeight - offset;
}
